/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject,PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/api.service';
import { QuickViewPopupService } from '../../services/quick-view-popup.service';
import { WindowService } from 'src/app/services/window.service';
import { PopupService } from '../../services/popup.service';
import { CartService } from '../../services/cart.service';
import { ProjectsService } from '../../services/project.service';
import { SaveIdeaService } from 'src/app/services/save-idea.service';

@Component({
  selector: 'app-quick-view-popup',
  templateUrl: './quick-view-popup.component.html',
  styleUrls: ['./quick-view-popup.component.scss','../../product-v3/product-v3.component.scss']
})
export class QuickViewPopupComponent{
  
constructor(@Inject(PLATFORM_ID) private platformId: any, private window: WindowService, private _actRouter: ActivatedRoute, public _as: AppService, public _router: Router,public _qvs:QuickViewPopupService,public _pop: PopupService
,public _cart:CartService,public __project:ProjectsService,public _sis:SaveIdeaService){

}
//  ngOnInit(): void {
//    if(this._as.isUserLoggedIn){
//     this._sis.addToSpace(this._qvs.tagged_product, this._qvs.activeProductIndex);
//    }
//  }
}
